import { createFileRoute } from "@tanstack/react-router"

import { BillingView } from "@/features/billing/components/billing-view"
import {
  RECENT_TRANSACTIONS,
  billingOverviewQueryOptions,
  invoicesQueryOptions,
  statementQueryOptions,
  transactionsQueryOptions,
} from "@/features/billing/hooks/use-billing"
import { warm } from "@/lib/router/warm"

// Billing is a platform page — every customer has it, whatever utilities
// they hold — so it lives at the top level, not under a module.
export const Route = createFileRoute("/_shell/billing/")({
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient } }) => {
    // The statement pages in as you scroll back, so it's warmed apart.
    void queryClient.prefetchInfiniteQuery(statementQueryOptions())
    return warm(queryClient, [
      billingOverviewQueryOptions(),
      transactionsQueryOptions(RECENT_TRANSACTIONS),
      // The renewal invoice, once issued (five days before the 1st).
      invoicesQueryOptions({
        status: "open",
        documents: ["invoice"],
        limit: 10,
      }),
    ])
  },
  component: BillingView,
})
